import React from 'react';

import { Box } from '@mui/material';
import AccordionCDS from 'app/shared/componentsRestyled/coreDesignSystem/AccordionCDS';
import PropTypes from 'prop-types';

import { checklistListStyles } from '../Alerts.styles';
import ChecklistItem from '../ChecklistItem';

import AdditionalSummaryContent from './AdditionalSummaryContent';
import { accordionCategoryCustomStyles } from './ChecklistCategoryAccordion.styles';

const ChecklistCategoryAccordion = ({ category, statusDisplayType, isChecklistRecalculating }) => {
  const itemsCount = category.items.length;

  return (
    <AccordionCDS
      additionalSummaryContent={
        <AdditionalSummaryContent category={category} statusDisplayType={statusDisplayType} />
      }
      arrowSize={18}
      customStyles={accordionCategoryCustomStyles}
      title={category.name}
    >
      <Box sx={checklistListStyles}>
        {category.items.map((item, index) => (
          <ChecklistItem
            disabled={category.disabled || isChecklistRecalculating}
            isLast={itemsCount === index + 1}
            item={item}
            key={item.id}
            nestedLevel={1}
            statusDisplayType={statusDisplayType}
          />
        ))}
      </Box>
    </AccordionCDS>
  );
};

ChecklistCategoryAccordion.propTypes = {
  category: PropTypes.object.isRequired,
  statusDisplayType: PropTypes.string.isRequired,
  isChecklistRecalculating: PropTypes.bool.isRequired,
};

export default ChecklistCategoryAccordion;
